// VITE_ADMIN is always a string at runtime (Vite env vars are strings), so a plain
// truthy check would treat values like "false" or "0" as enabled. Compare explicitly
// against "1", the value actually set in launchSettings.json and the build pipeline.
export function isAdminBuild(): boolean {
  return import.meta.env.VITE_ADMIN === "1";
}
